/*
 * File: AsanaCard.tsx
 * Project: a-a
 * File Created: Tuesday, 22nd April 2025 8:41:10 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 21st July 2025 11:57:30 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import { Box, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';
import LinearProgress from '@mui/material/LinearProgress';
import CustomOverlapImg from '../../../shared/CustomOverlapImg/CustomOverlapImg';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import { Link, useNavigate } from 'react-router-dom';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import AsanaAddProject from '../AsanaAddProject/AsanaAddProject';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import { AsanaService } from '../../../../service/asana.service';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';

const AsanaCard = ({
  item,
  loading,
  setCopy,
  getProjects,
  setMessage,
}: {
  item: any;
  loading: boolean;
  setCopy: React.Dispatch<React.SetStateAction<string>>;
  getProjects: () => void;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selected, setSelected] = React.useState<any>();
  const [anchorEl, setAnchorEl] = useState<HTMLImageElement | null>(null);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const [copy, setCopy] = useState('');
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    // console.log(event.currentTarget);
    setAnchorEl(event.target as HTMLImageElement);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleCopyLink = (val: any) => {
    navigator.clipboard.writeText(val);
    setCopy('Link copied');
  };
  const handleClose = () => {
    setCopy('');
    setMessage('');
  };
  const handleDeleteClick = async () => {
    try {
      await AsanaService.deleteAsanaProject(selected?.id);
      getProjects();
      setMessage('Project deleted successfully');
    } catch (err) {
      // console.log(err);
      setMessage('Something went wrong');
    }
  };
  const handleNavigate = (e: any) => {
    // console.log(e.target);
    if (e.target?.alt === 'options-icon') {
      handleClick(e);
    } else if (anchorEl) {
      setAnchorEl(null);
    } else {
      navigate(`${item?.id}`, { state: { selectedProject: item } });
    }
  };
  const handleEdit = () => {
    setModalOpen(true);
    setSelected(item);
  };
  const handleDeleteClose = () => {
    setOpenDeleteModal(false);
  };

  return (
    <Box>
      <Box
        sx={{
          borderRadius: '16px',
          padding: '16px',
          backgroundColor: zeplinColor.Neutral1,
          border: `1px solid ${zeplinColor.Neutral5}`,
          ':hover': {
            ...(!loading && {
              border: `1px solid ${zeplinColor.BasicBlack}`,
            }),
          },
          // width: '195.5px',
          height: '215px',
          display: 'flex',
          flexDirection: 'column',
          // justifyContent: 'center',
          alignItems: 'flex-start',
          //   alignItems: 'center',
          flex: 1,
          gap: '24px',
        }}
        onClick={(e: any) => handleNavigate(e)}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%', flex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              gap: '8px',
              justifyContent: 'space-between',
              flex: 1,
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  flex: 1,
                  // Optionally adjust other styles here
                }}
              />
            ) : item?.name?.length < 60 ? (
              <Typography variant='body2'>{item?.name}</Typography>
            ) : (
              <LightTooltip
                title={
                  <Typography variant='body2' color={zeplinColor.Neutral1}>
                    {item?.name}
                  </Typography>
                }
                placement='bottom-end'
                style={{
                  backgroundColor: zeplinColor.BasicBlack,
                  borderRadius: '8px',
                  padding: '12px',
                }}
                // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
              >
                <Typography variant='body2'>
                  {item?.name?.slice(0, 59)}
                  {item?.name?.length > 60 ? '...' : ''}
                </Typography>
              </LightTooltip>
            )}
            {loading ? (
              ''
            ) : (
              <img
                width={'18px'}
                height={'18px'}
                src={'/assets/vertical-dots.svg'}
                alt='options-icon'
                onClick={(e) => handleClick(e)}
                aria-hidden='false'
                // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
              />
            )}
          </Box>

          <Box
            sx={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', flex: 1 }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Typography variant='body3'>{item?.totalTasks} Total Task</Typography>
                {item?.overdue && (
                  <LightTooltip
                    title={
                      <Typography variant='body2' color={zeplinColor.Neutral1}>
                        {item?.overdues} Task overdue
                      </Typography>
                    }
                    placement='bottom-end'
                    style={{
                      backgroundColor: zeplinColor.BasicBlack,
                      borderRadius: '8px',
                      padding: '12px',
                    }}
                    // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
                  >
                    <img
                      width={'22px'}
                      height={'22px'}
                      src={'/assets/overdue-icon.svg'}
                      alt='overdue-icon'
                      onClick={() => {}}
                      aria-hidden='false'
                      // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
                    />
                  </LightTooltip>
                )}
              </Box>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography color={zeplinColor.Neutral9} variant='body3'>
                    Progress{' '}
                  </Typography>
                  <Typography color={zeplinColor.Neutral9} variant='body3'>
                    {item?.donePercent}%
                  </Typography>
                </Box>
              )}
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <LinearProgress
                  variant='determinate'
                  value={item?.donePercent}
                  sx={{
                    //   flex: 1,
                    borderRadius: '8px',
                    height: '8px',
                    backgroundColor: zeplinColor.Neutral4,
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: zeplinColor.Green4,
                    },
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>

        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              // Optionally adjust other styles here
            }}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              // flex: 1,
              alignItems: 'center',
              width: '100%',
            }}
          >
            {item?.members?.length > 0 && (
              <CustomOverlapImg
                images={item?.members?.filter((val: any) => val).map((val: any) => val?.photo)}
                name={item?.members?.map((val: any) => val?.name)}
              />
            )}
            <Chip
              label={
                <Typography
                  variant='label1'
                  color={zeplinColor.Neutral1}
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {item?.team?.name}
                </Typography>
              }
              sx={{
                backgroundColor: zeplinColor.BasicBlack,
                padding: '5px 12px 5px 12px',
                borderRadius: '50px',
                // width: '47px',
                height: '24px',
                '& .MuiChip-label': {
                  padding: '0px',
                },
              }}
            />
          </Box>
        )}

        <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              padding: '16px',
            }}
          >
            <Link to={`${item?.id}`} style={{ textDecoration: 'none' }}>
              <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                <img src={'/assets/view.svg'} width={18} height={18} />
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  View details
                </Typography>
              </Box>
            </Link>

            <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }} onClick={handleEdit}>
              <img src={'/assets/edit.svg'} width={18} height={18} />
              <Typography variant='body3' color={zeplinColor.BasicBlack}>
                Edit project
              </Typography>
            </Box>

            <Box
              sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
              onClick={() => handleCopyLink(item?.projectLink)}
            >
              <img src={'/assets/copy-link.svg'} width={18} height={18} />
              <Typography variant='body3' color={zeplinColor.BasicBlack}>
                Copy link
              </Typography>
            </Box>

            <Box
              sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
              onClick={(e) => {
                setOpenDeleteModal(true);
                setSelected(item);
                setAnchorEl(null);
              }}
            >
              <img src={'/assets/delete-red.png'} width={18} height={18} />
              <Typography variant='body3' color={zeplinColor.Error}>
                Delete
              </Typography>
            </Box>
          </Box>
        </CustomPopOver>
      </Box>
      {selected?.id === item?.id && (
        <AsanaAddProject
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          data={selected}
          key={selected?.id}
          getProjects={getProjects}
          setMessage={setMessage}
        />
      )}
      <CustomModal handleClose={handleDeleteClose} open={openDeleteModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              // width: '312px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Project
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  Are you sure you want to delete this project?
                  <br /> This action cannot be undone, and all project
                  <br /> details will be permanently removed.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: '16px',
                }}
              >
                <Box
                  onClick={() => {
                    handleDeleteClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    handleDeleteClick();
                    handleDeleteClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      Delete
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
    </Box>
  );
};

export default AsanaCard;
